/** 퀘스트 세트 완료 보상 라벨 — 신규 both와 레거시 단일 보상 호환. */
export function formatQuestSetReward(reward = {}, couponFallback = '보상 쿠폰') {
  const parts = [];
  if (reward.reward_type === 'coin' || reward.reward_type === 'both') {
    parts.push(`주렁주화 ${reward.reward_coin_amount ?? '-'}개`);
  }
  if (reward.reward_type === 'coupon' || reward.reward_type === 'both') {
    parts.push(reward.reward_coupon_name || reward.coupon_name || couponFallback);
  }
  return parts.join(' + ');
}
